export class OrigenCpj {
    constructor(config = {}) {
        const tipoFrmEmpresa = config.tipoFrmEmpresa;

        this.model = {
            transaccion_realiza: {
                value: '',
                header: 'Describa la transacción u operación que realiza con la compañía:',
                // Headers alternativos según catalogos?.tipoFrmEmpresa. Si el tipo actual no está mapeado, se usa 'header'.
                headerPorTipo: {
                    FRM_TOYOTA: 'Motivo de compra del bien:',
                },
                required: 'Describa la transacción u operación que realiza con la compañía es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4
            },
            valor_total_bien_servicio: {
                value: 0,
                header: 'Valor total del bien/servicio:',
                required: 'Valor total del bien/servicio es requerido',
            },
            moneda: {
                value: null,
                header: 'Moneda:',
                required: 'Moneda es requerido',
            },
            fecha_transaccion: {
                value: new Date(),
                export: false,
                header: 'Fecha de la transacción u operación (día/mes/año):',
                required: 'Fecha de la transacción u operación es requerida',
            },
            proposito_relacion: {
                value: '',
                header: 'Propósito de la relación comercial o contractual/ Motivo de compra del bien:',
                required: 'Campo requerido',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4
            },
            ubicacion_bien: {
                value: '',
                header: 'Ubicación del bien:',
                required: 'Campo requerido',
                maxLength: 'Máximo 250 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 250,
                min: 4
            },
            pais_ol: {
                value: null,
                header: 'País:',
                headerPorTipo: {
                    FRM_DIFARE: 'País de donde proviene el pago:',
                },
                required: 'País es requerido'
            },
            provincia_ol: {
                value: null,
                header: 'Provincia:',
                headerPorTipo: {
                    FRM_DIFARE: 'Provincia de donde proviene el pago:',
                },
                required: 'Provincia es requerido'
            },
            ciudad_ol: {
                value: null,
                header: 'Ciudad:',
                headerPorTipo: {
                    FRM_DIFARE: 'Ciudad de donde proviene el pago:',
                },
                required: 'Ciudad es requerida'
            },
            canton_ol: {
                value: '',
                header: 'Ciudad',
                headerPorTipo: {
                    FRM_DIFARE: 'Ciudad de donde proviene el pago:',
                },
                maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 100,
                min: 4,
                required: 'Ciudad es requerida'
            },
            detalle_act_economica: {
                value: '',
                header: 'Los valores entregados provienen de (detalle actividad económica o fuente):',
                headerPorTipo: {
                    FRM_DIFARE: 'Los valores entregados y los que se entregarán, provienen de la siguiente actividad económica o fuente:',
                },
                required: 'Los valores entregados provienen es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
            },
            tipo_valor_entregado: {
                value: null,
                required: 'Seleccione una opción',
                header: 'Los valores entregados son:'
            },
        }

        // Resuelve, por cada campo con 'headerPorTipo', el header correspondiente a tipoFrmEmpresa.
        // Si no hay coincidencia (u otro tipoFrmEmpresa), se conserva el 'header' definido arriba.
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
        });
    }
    optionLabel = 'nombre';
    declaracion = <>Declaro bajo juramento que los valores entregados son lícitos, no provienen de actividades de lavado de activos, financiamiento del terrorismo y otros delitos y
        son generados de actividades económicas legales declaradas en el presente formulario</>
}
